import { ClinksStatusOption, IncludeExclude } from "../../../utils/types";
import AutocompleteSingle from "../../library/AutocompleteSingle";
import CLINKS_STATUS_OPTIONS from "./clinksStatusOptions";

interface ClinksStatusAutocompleteProps {
  onChange: (selected: ClinksStatusOption[]) => void;
  selected: ClinksStatusOption[];
  reactRef?: any;
  disabled?: boolean;
  style?: {[key:string]:string};
  useIncludeExclude?: boolean;
  defaultIncludeExclude?: IncludeExclude;
  includeExcludeOnChange?: (newIncludeExclude:IncludeExclude) => void;
  options?: ClinksStatusOption[]; // Allow custom options, fallback to default
}

function ClinksStatusAutocomplete(props: ClinksStatusAutocompleteProps) {
  const labelKeyFunction = (option: ClinksStatusOption) => {
    return option.name;
  }

  return (
    <AutocompleteSingle
      placeholder="cLinks Status"
      reactKey="clinksStatusAutocomplete" 
      labelKey={labelKeyFunction}
      onChange={props.onChange}
      options={props.options || CLINKS_STATUS_OPTIONS}
      selected={props.selected}
      style={props.style}
    />
  );
}

export default ClinksStatusAutocomplete;